import React from 'react';
import {
  Button, Row, Col, Select, DatePicker, Card,
} from 'antd';
import { USER_DATE_FORMAT } from '../../../../utils/constants';

const SearchBox = ({
  styleName, onChange, value,
}) => {
  // eslint-disable-next-line no-unused-vars
  function handleButtonClick(e) {
    console.log('click left button', e);
  }

  function handleMenuClick(e) {
    console.log('click', e);
  }

  const { Option } = Select;

  function handleChange(value) {
    console.log(`selected ${value}`);
  }

  function handleBlur() {
    console.log('blur');
  }

  function handleFocus() {
    console.log('focus');
  }

  return (
    <Row>
      <Col lg={24} md={24} sm={24} xs={24}>
        <Card>
          <div className={`gx-search-bar ${styleName}`}>
            <Row>

              <Col lg={9} md={9} sm={24} xs={24}>
                <div className="ant-input-search ant-input-affix-wrapper">
                  <input
                    className="ant-input"
                    type="search"
                    placeholder="Номер накладной или вызова курьера"
                    onChange={handleButtonClick}
                    value={value}
                  />
                </div>

              </Col>

              <Col lg={5} md={5} sm={24} xs={24}>
                <div className="ant-input-search ant-input-affix-wrapper">
                  <input
                    className="ant-input"
                    type="search"
                    placeholder="Клиент или автор обращения"
                    onChange={handleButtonClick}
                    value={value}
                  />
                </div>

              </Col>
              <Col lg={5} md={5} sm={12} xs={24}>
                <div className="gx-form-group">
                  <DatePicker
                    className="gx-mb-3 gx-w-100"
                    placeholder="Дата создания"
                    onChange={onChange}
                    format={USER_DATE_FORMAT}
                  />

                </div>

              </Col>

              <Col lg={5} md={5} sm={12} xs={24}>
                <div className="gx-form-group">
                  <Button className="gx-w-100 btn btn-primary">
                    Найти
                  </Button>
                </div>

              </Col>
            </Row>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

SearchBox.defaultProps = {
  styleName: '',
  value: '',
};

export default SearchBox;
